var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"glide",staticClass:"sf-grouped-product",class:{
    glide: _vm.hasCarousel,
    'sf-grouped-product--without-carousel': !_vm.hasCarousel,
  }},[_c('div',{class:{ glide__track: true },attrs:{"data-glide-el":"track"}},[_c('ul',{ref:"slides",class:{
        glide__slides: true,
      }},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }